import { BlockchainNetwork, ConstantsHelper, WalletType } from "@renec-foundation/relend-adapter"
import { NATIVE_MINT } from "@solana/spl-token"
import BigNumber from "bignumber.js"

// PADDING TO CALCULATE RENEC FOR RENT AND FEE
export const RENEC_PADDING_FOR_RENT_AND_FEE =
  parseFloat(process.env.NEXT_PUBLIC_RENEC_PADDING_FOR_RENT_AND_FEE ?? "0") || 0.0025 // Set to 0 to disable

export const SOL_PADDING_FOR_RENT_AND_FEE = 0.02

export const FIAT_DECIMALS = 0

export const WITHDRAW_MAX_LIMIT_ERROR_PERCENTAGE = 0.0005 // 0.005%

export const REPAY_MAX_LIMIT_ERROR_PERCENTAGE = 0.0005 // 0.005%

export const SOL_PADDING_WITH_BUFFER = SOL_PADDING_FOR_RENT_AND_FEE * 0.9
export const RENEC_PADDING_WITH_BUFFER = RENEC_PADDING_FOR_RENT_AND_FEE * 0.9

export function sufficientNativeTokenForTransaction(network: BlockchainNetwork, wallet: WalletType) {
  const amountPadding = ConstantsHelper.isRenecChain(network)
    ? RENEC_PADDING_FOR_RENT_AND_FEE
    : SOL_PADDING_FOR_RENT_AND_FEE
  return wallet
    .find((a) => a.mintAddress === NATIVE_MINT.toBase58())
    ?.amount?.isGreaterThanOrEqualTo(new BigNumber(amountPadding).times(0.9))
}

export function sufficientNativeTokenForTransactionWithValue(
  network: BlockchainNetwork,
  wallet: WalletType,
  amount: BigNumber,
) {
  const nativeTokenBalance = wallet.find((a) => a.mintAddress === NATIVE_MINT.toBase58())?.amount
  const amountPadding = ConstantsHelper.isRenecChain(network)
    ? RENEC_PADDING_FOR_RENT_AND_FEE
    : SOL_PADDING_FOR_RENT_AND_FEE
  return (
    nativeTokenBalance?.isGreaterThanOrEqualTo(new BigNumber(amountPadding)) &&
    nativeTokenBalance?.minus(amount).isGreaterThanOrEqualTo(new BigNumber(amountPadding))
  )
}
